// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("rescript/lib/js/curry.js");
var Media = require("../../common/Media/Media.bs.js");
var React = require("react");
var Tooltip = require("../../common/Tooltip.bs.js");
var Theme__Color = require("../../common/Theme/Theme__Color.bs.js");

var underlineStyle = Curry._1(Css.style, {
      hd: Css.display("inlineBlock"),
      tl: {
        hd: Media.minWidth("md")({
              hd: Css.textDecoration("underline"),
              tl: {
                hd: Css.textDecorationStyle("dotted"),
                tl: {
                  hd: Css.textDecorationColor(Theme__Color.silver),
                  tl: /* [] */0
                }
              }
            }),
        tl: /* [] */0
      }
    });

function Clients__Components__AreaText(props) {
  var area = props.area;
  return React.createElement(Tooltip.make, {
              label: area.label,
              children: React.createElement("span", {
                    className: underlineStyle
                  }, area.name)
            });
}

function jsAreaToReason(a) {
  return {
          id: a.id,
          name: a.name,
          label: a.label,
          type_: a.type_,
          state: a.state
        };
}

var make = Clients__Components__AreaText;

exports.underlineStyle = underlineStyle;
exports.make = make;
exports.jsAreaToReason = jsAreaToReason;
/* underlineStyle Not a pure module */
